module.exports = __webpack_public_path__ + "static/media/research-2-screenshot.6b611095.webp";